import script from "./PrivateAllProductsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivateAllProductsItem.vue?vue&type=script&setup=true&lang=js"

import "./PrivateAllProductsItem.vue?vue&type=style&index=0&id=11e2e694&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11e2e694"]])

export default __exports__